var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIconNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44683 21.6002L2.64697 25.6499L7.52157 24.075C10.1773 25.5764 13.3006 26.0237 16.271 25.328C19.2413 24.6323 21.8412 22.8446 23.5541 20.3201C25.2669 17.7955 25.9672 14.719 25.5159 11.7018C25.0646 8.68468 23.4946 5.94774 21.1181 4.0349C18.7415 2.12207 15.7323 1.17335 12.6884 1.37729C9.6445 1.58123 6.78873 2.92289 4.68859 5.13566C2.58845 7.34843 1.39767 10.2703 1.35287 13.3207C1.30808 16.3711 2.41256 19.3267 4.44683 21.6002Z",
    stroke: "black",
    strokeWidth: 2.69978,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44364 15.2061C9.18916 15.2061 9.79353 14.6018 9.79353 13.8562C9.79353 13.1107 9.18916 12.5063 8.44364 12.5063C7.69812 12.5063 7.09375 13.1107 7.09375 13.8562C7.09375 14.6018 7.69812 15.2061 8.44364 15.2061Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6897 15.2061C14.4353 15.2061 15.0396 14.6018 15.0396 13.8562C15.0396 13.1107 14.4353 12.5063 13.6897 12.5063C12.9442 12.5063 12.3398 13.1107 12.3398 13.8562C12.3398 14.6018 12.9442 15.2061 13.6897 15.2061Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9397 15.2061C19.6853 15.2061 20.2896 14.6018 20.2896 13.8562C20.2896 13.1107 19.6853 12.5063 18.9397 12.5063C18.1942 12.5063 17.5898 13.1107 17.5898 13.8562C17.5898 14.6018 18.1942 15.2061 18.9397 15.2061Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconNew);
export default __webpack_public_path__ + "static/media/chat-icon-new.bd231a5b1eac66344c0676bee3b66950.svg";
export { ForwardRef as ReactComponent };